// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.StudyCard_study-card__cs-25 {
  overflow: hidden;
  border: 1px solid rgba(19, 35, 29, 0.09);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.45);
  transition: border-color 0.18s ease, background 0.18s ease;
  margin-bottom: 9px;
}
.StudyCard_study-card__cs-25[open] {
  border-color: rgba(130, 177, 148, 0.42);
  background: rgba(130, 177, 148, 0.055);
}

.StudyCard_study-summary__qbU47 {
  width: 100%;
  min-height: 66px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 16px 18px;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  list-style: none;
  text-align: left;
}
.StudyCard_study-summary__qbU47::-webkit-details-marker {
  display: none;
}

.StudyCard_study-heading__QPc5S {
  min-width: 0;
  display: grid;
  gap: 4px;
}
.StudyCard_study-heading__QPc5S strong {
  font-size: 14px;
  font-weight: 750;
  line-height: 1.4;
  color: #13231d;
}
.StudyCard_study-heading__QPc5S span {
  font-size: 12px;
  color: rgba(21, 36, 30, 0.55);
  font-weight: 650;
  line-height: 1.4;
}

.StudyCard_study-plus__4vx4T {
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(130, 177, 148, 0.3);
  border-radius: 50%;
  background: transparent;
  color: #5E806C;
  font-size: 18px;
  line-height: 1;
  transition: transform 0.2s ease, background 0.18s ease, color 0.18s ease;
}
.StudyCard_study-card__cs-25[open] .StudyCard_study-plus__4vx4T {
  transform: rotate(45deg);
  background: #82b194;
  color: #fff;
  border-color: #82b194;
}

.StudyCard_study-content__d51Q2 {
  margin: 0 58px 0 18px;
  padding: 0 0 17px;
  color: #52635c;
  font-size: 13px;
  line-height: 1.7;
}

.StudyCard_study-meta__1tOQt {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  color: #7d8883;
  font-size: 10px;
  line-height: 1.4;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 0;
}
.StudyCard_study-meta__1tOQt::before {
  content: "";
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #C8E2D1;
  flex-shrink: 0;
}

.StudyCard_study-actions__qYVq5 {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.StudyCard_study-type__6ZO0A {
  display: inline-flex;
  align-items: center;
  min-height: 30px;
  padding: 0 10px;
  border: 1px solid rgba(130, 177, 148, 0.2);
  border-radius: 10px;
  background: rgba(130, 177, 148, 0.07);
  font-size: 11px;
  font-weight: 800;
  color: #13231d;
  width: fit-content;
}

.StudyCard_study-footer__GRkNL {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding-top: 14px;
  border-top: 1px dashed rgba(19, 35, 29, 0.09);
}

.StudyCard_study-card__badge__iVY4M {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 26px;
  padding: 0 12px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background: rgba(16, 25, 21, 0.08);
  color: #65756E;
  border: 1px solid rgba(16, 25, 21, 0.1);
}
.StudyCard_study-card__badge--cuerpo__pvRWJ {
  background: color-mix(in srgb, #304e8f 14%, white 86%);
  color: #304e8f;
  border: 1px solid color-mix(in srgb, #304e8f 32%, white 68%);
}
.StudyCard_study-card__badge--conciencia__lRK31 {
  background: color-mix(in srgb, #5C9DD6 14%, white 86%);
  color: #5C9DD6;
  border: 1px solid color-mix(in srgb, #5C9DD6 32%, white 68%);
}
.StudyCard_study-card__badge--mente__5SuaM {
  background: color-mix(in srgb, #695EA6 14%, white 86%);
  color: #695EA6;
  border: 1px solid color-mix(in srgb, #695EA6 32%, white 68%);
}
.StudyCard_study-card__badge--energia__-7v-h {
  background: color-mix(in srgb, #4FB08C 14%, white 86%);
  color: #4FB08C;
  border: 1px solid color-mix(in srgb, #4FB08C 32%, white 68%);
}

.StudyCard_study-card__action__8Tp3T {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  padding: 0;
  color: #82B194;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
  font-family: "Sora", sans-serif;
  transition: all 0.2s ease;
}
.StudyCard_study-card__action__8Tp3T:hover {
  color: rgb(88.5665024631, 141.9334975369, 109.0049261084);
  text-decoration: underline;
}

.StudyCard_study-card__arrow__YTvSr {
  transition: transform 0.2s ease;
  display: inline-block;
}

@media (max-width: 650px) {
  .StudyCard_study-card__cs-25 {
    border-radius: 14px;
  }
  .StudyCard_study-summary__qbU47 {
    min-height: 60px;
    padding: 14px 16px;
  }
  .StudyCard_study-content__d51Q2 {
    margin: 0 16px 0 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/DetailPage/StudyCard/StudyCard.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AATA;EACI,gBAAA;EACA,wCAAA;EACA,mBAAA;EACA,qCAAA;EACA,0DAAA;EACA,kBAAA;AAYJ;AAVI;EACI,uCAAA;EACA,sCAAA;AAYR;;AARA;EACI,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAWJ;AATI;EACI,aAAA;AAWR;;AAPA;EACI,YAAA;EACA,aAAA;EACA,QAAA;AAUJ;AARI;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cA/CE;AAyDV;AAPI;EACI,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,gBAAA;AASR;;AALA;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,wEAAA;AAQJ;AANI;EACI,wBAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;AAQR;;AAJA;EACI,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAOJ;;AAJA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;AAOJ;AALI;EACI,WAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AAOR;;AAHA;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AAMJ;;AAHA;EACI,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,0CAAA;EACA,mBAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAMJ;;AAHA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,6CAAA;AAMJ;;AAHA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kCA1JQ;EA2JR,cA5Ja;EA6Jb,uCAAA;AAMJ;AAJI;EACI,sDAAA;EACA,cAAA;EACA,4DAAA;AAMR;AAHI;EACI,sDAAA;EACA,cAAA;EACA,4DAAA;AAKR;AAFI;EACI,sDAAA;EACA,cAAA;EACA,4DAAA;AAIR;AADI;EACI,sDAAA;EACA,cAAA;EACA,4DAAA;AAGR;;AACA;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;EACA,UAAA;EACA,cAjMS;EAkMT,eAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,yBAAA;AAEJ;AAAI;EACI,yDAAA;EACA,0BAAA;AAER;;AAEA;EACI,+BAAA;EACA,qBAAA;AACJ;;AAEA;EACI;IACI,mBAAA;EACN;EAEE;IACI,gBAAA;IACA,kBAAA;EAAN;EAGE;IACI,qBAAA;EADN;AACF","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../../assets/styles/variables';\n\n$bw-primary: #82B194;\n$bw-text: #13231d;\n$bw-muted-solid: #65756E;\n$bw-border: rgba(16, 25, 21, 0.08);\n\n.study-card {\n    overflow: hidden;\n    border: 1px solid rgba(19, 35, 29, 0.09);\n    border-radius: 16px;\n    background: rgba(255, 255, 255, 0.45);\n    transition: border-color 0.18s ease, background 0.18s ease;\n    margin-bottom: 9px;\n\n    &[open] {\n        border-color: rgba(130, 177, 148, 0.42);\n        background: rgba(130, 177, 148, 0.055);\n    }\n}\n\n.study-summary {\n    width: 100%;\n    min-height: 66px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 18px;\n    padding: 16px 18px;\n    border: 0;\n    background: transparent;\n    color: inherit;\n    cursor: pointer;\n    list-style: none;\n    text-align: left;\n\n    &::-webkit-details-marker {\n        display: none;\n    }\n}\n\n.study-heading {\n    min-width: 0;\n    display: grid;\n    gap: 4px;\n\n    strong {\n        font-size: 14px;\n        font-weight: 750;\n        line-height: 1.4;\n        color: $bw-text;\n    }\n\n    span {\n        font-size: 12px;\n        color: rgba(21, 36, 30, 0.55);\n        font-weight: 650;\n        line-height: 1.4;\n    }\n}\n\n.study-plus {\n    flex: 0 0 28px;\n    width: 28px;\n    height: 28px;\n    display: grid;\n    place-items: center;\n    border: 1px solid rgba(130, 177, 148, 0.30);\n    border-radius: 50%;\n    background: transparent;\n    color: #5E806C;\n    font-size: 18px;\n    line-height: 1;\n    transition: transform 0.2s ease, background 0.18s ease, color 0.18s ease;\n\n    .study-card[open] & {\n        transform: rotate(45deg);\n        background: #82b194;\n        color: #fff;\n        border-color: #82b194;\n    }\n}\n\n.study-content {\n    margin: 0 58px 0 18px;\n    padding: 0 0 17px;\n    color: #52635c;\n    font-size: 13px;\n    line-height: 1.7;\n}\n\n.study-meta {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n    color: #7d8883;\n    font-size: 10px;\n    line-height: 1.4;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n    margin-bottom: 0;\n\n    &::before {\n        content: '';\n        display: inline-block;\n        width: 6px;\n        height: 6px;\n        border-radius: 50%;\n        background: #C8E2D1;\n        flex-shrink: 0;\n    }\n}\n\n.study-actions {\n    margin-top: 15px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.study-type {\n    display: inline-flex;\n    align-items: center;\n    min-height: 30px;\n    padding: 0 10px;\n    border: 1px solid rgba(130, 177, 148, 0.20);\n    border-radius: 10px;\n    background: rgba(130, 177, 148, 0.07);\n    font-size: 11px;\n    font-weight: 800;\n    color: #13231d;\n    width: fit-content;\n}\n\n.study-footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    width: 100%;\n    padding-top: 14px;\n    border-top: 1px dashed rgba(19, 35, 29, 0.09);\n}\n\n.study-card__badge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 26px;\n    padding: 0 12px;\n    border-radius: 999px;\n    font-size: 10px;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    background: $bw-border;\n    color: $bw-muted-solid;\n    border: 1px solid rgba(16, 25, 21, 0.1);\n\n    &--cuerpo {\n        background: color-mix(in srgb, #304e8f 14%, white 86%);\n        color: #304e8f;\n        border: 1px solid color-mix(in srgb, #304e8f 32%, white 68%);\n    }\n\n    &--conciencia {\n        background: color-mix(in srgb, #5C9DD6 14%, white 86%);\n        color: #5C9DD6;\n        border: 1px solid color-mix(in srgb, #5C9DD6 32%, white 68%);\n    }\n\n    &--mente {\n        background: color-mix(in srgb, #695EA6 14%, white 86%);\n        color: #695EA6;\n        border: 1px solid color-mix(in srgb, #695EA6 32%, white 68%);\n    }\n\n    &--energia {\n        background: color-mix(in srgb, #4FB08C 14%, white 86%);\n        color: #4FB08C;\n        border: 1px solid color-mix(in srgb, #4FB08C 32%, white 68%);\n    }\n}\n\n.study-card__action {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    background: transparent;\n    border: none;\n    padding: 0;\n    color: $bw-primary;\n    font-size: 13px;\n    font-weight: 800;\n    cursor: pointer;\n    font-family: \"Sora\", sans-serif;\n    transition: all 0.2s ease;\n\n    &:hover {\n        color: darken($bw-primary, 15%);\n        text-decoration: underline;\n    }\n}\n\n.study-card__arrow {\n    transition: transform 0.2s ease;\n    display: inline-block;\n}\n\n@media (max-width: 650px) {\n    .study-card {\n        border-radius: 14px;\n    }\n\n    .study-summary {\n        min-height: 60px;\n        padding: 14px 16px;\n    }\n\n    .study-content {\n        margin: 0 16px 0 16px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"study-card": `StudyCard_study-card__cs-25`,
	"study-summary": `StudyCard_study-summary__qbU47`,
	"study-heading": `StudyCard_study-heading__QPc5S`,
	"study-plus": `StudyCard_study-plus__4vx4T`,
	"study-content": `StudyCard_study-content__d51Q2`,
	"study-meta": `StudyCard_study-meta__1tOQt`,
	"study-actions": `StudyCard_study-actions__qYVq5`,
	"study-type": `StudyCard_study-type__6ZO0A`,
	"study-footer": `StudyCard_study-footer__GRkNL`,
	"study-card__badge": `StudyCard_study-card__badge__iVY4M`,
	"study-card__badge--cuerpo": `StudyCard_study-card__badge--cuerpo__pvRWJ`,
	"study-card__badge--conciencia": `StudyCard_study-card__badge--conciencia__lRK31`,
	"study-card__badge--mente": `StudyCard_study-card__badge--mente__5SuaM`,
	"study-card__badge--energia": `StudyCard_study-card__badge--energia__-7v-h`,
	"study-card__action": `StudyCard_study-card__action__8Tp3T`,
	"study-card__arrow": `StudyCard_study-card__arrow__YTvSr`
};
export default ___CSS_LOADER_EXPORT___;
